<template>
  <div id="app" :class="{sideOpen: openSide}">
    <ContactFloatingBtn />
    <div class="modal-container" v-if="showModal">
      <div class="modal-bg">
        <div class="modal">
          <div class="modal-header">
            <div class="modal-title">이메일 확인</div>
            <button @click="closeModal"><img src="@/assets/icons/icon-close.svg" alt="" /></button>
          </div>
          <div class="modal-body">이메일을 입력해주세요</div>
          <div class="modal-footer">
            <button class="btn-slim sub">취소</button>
            <button class="btn-slim primary">확인</button>
          </div>
        </div>
      </div>
    </div>
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import { bus } from './main';
import Footer from './components/Footer.vue';
import Header from './components/Header.vue';
import ContactFloatingBtn from './components/ContactFloatingBtn.vue';
// import HeroSlider from './components/HeroSlider.vue'
// import ContactFormPage from './views/ContactFormPage.vue'
// import ContactPage from './views/ContactPage.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    ContactFloatingBtn,
    // ContactPage,
    // ContactFormPage,
    // HeroSlider
  },
  props: {},
  created() {
    bus.$on('showModal', () => {
      this.showModal = true
    });
    bus.$on('openSide', () => {
      this.openSide = true
    });
  },
  data() {
    return {
      showModal: false,
      openSide: false,
    };
  },
  methods: {
    closeModal() {
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/scss/styles.scss';
</style>
